import React from "react";
import clsx from "clsx";

import RequestCheck from "../../../../assets/img/rent-requested-check.png";
import RentCheck from "../../../../assets/img/rent-check.png";
import ReturnCheck from "../../../../assets/img/return-check.png";

type Props = { step: number };

export default function ProgressIconGroup({ step }: Props) {
  const dataList = [
    {
      icon: RequestCheck,
      alt: "request",
    },
    {
      icon: RentCheck,
      alt: "rent",
    },
    {
      icon: ReturnCheck,
      alt: "return",
    },
  ];

  return (
    <div className="flex gap-[36px]">
      {dataList.map((item, index) => (
        <img
          key={index}
          src={item.icon}
          alt={`${item.alt}-check`}
          className={clsx([
            "h-[71px] w-[71px]",
            {
              "blur-[2px] grayscale": index !== step,
            },
          ])}
        />
      ))}
    </div>
  );
}
